import { JSX } from "react";

export const getGenericErrorMessage = () : JSX.Element => (
  <><strong>Uh oh! </strong>An unexpected error occurred. If the issue persists, please contact your administrator.</>
);
